import { browserHistory } from 'react-router'
import React, {Component} from 'react'
import ProductEditForm from "./form/edit.component.jsx"
import SideBar from '../common/layout/sidebar.component.jsx'

class AssemblyNew extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
        }
    }

    componentDidMount() {
        SideBar.activateMenu('product')
    }

    render() {
        return (
            <div>
                <ProductEditForm defaultState={{type: 'assembly'}} />
            </div>
        );
    }
}

export default AssemblyNew


// WEBPACK FOOTER //
// ./src/product/newassembly.component.jsx